import { KenoDataServiceAPI } from '@API/gambyt-data-services/keno-api'
import { DataFetchingState } from '@AppState/types'
import { HotAndColdNumbersResponse } from '@interaction-gaming/game-data-service-browser-client'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

export type AnalyticsModeState = {
  fetchState: DataFetchingState
  response: HotAndColdNumbersResponse | null
}

export type FetchHotColdNumbersRequest = {
  numDraws: number
  numHotNumbers?: number
  numColdNumbers?: number
  drawNumber?: number
}

const initialState: AnalyticsModeState = {
  fetchState: DataFetchingState.IDLE,
  response: null,
}

export const fetchAnalyticsModeHotColdNumbers = createAsyncThunk(
  'analytics-mode/fetchHotColdNumbers',
  async (args: FetchHotColdNumbersRequest) => {
    return await KenoDataServiceAPI.fetchHotColdNumbers(
      args.numDraws,
      args.numHotNumbers,
      args.numColdNumbers,
    )
  },
)

export const analyticsModeSlice = createSlice({
  name: 'analytics-mode',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAnalyticsModeHotColdNumbers.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.response = action.payload
    })
    builder.addCase(fetchAnalyticsModeHotColdNumbers.pending, (state) => {
      state.fetchState = DataFetchingState.PENDING
    })
    builder.addCase(fetchAnalyticsModeHotColdNumbers.rejected, (state, action) => {
      console.error(action.error)
      state.fetchState = DataFetchingState.FAILED
    })
  },
})

export const AnalyticsModeActions = {
  ...analyticsModeSlice.actions,
}

export const AnalyticsModeReducer = analyticsModeSlice.reducer
